var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333334C3.31992 0.333334 0.333252 3.32 0.333252 7C0.333252 10.68 3.31992 13.6667 6.99992 13.6667C10.6799 13.6667 13.6666 10.68 13.6666 7C13.6666 3.32 10.6799 0.333334 6.99992 0.333334ZM5.19325 9.86L2.79992 7.46667C2.53992 7.20667 2.53992 6.78667 2.79992 6.52667C3.05992 6.26667 3.47992 6.26667 3.73992 6.52667L5.66659 8.44667L10.2533 3.86C10.5133 3.6 10.9333 3.6 11.1933 3.86C11.4533 4.12 11.4533 4.54 11.1933 4.8L6.13325 9.86C5.87992 10.12 5.45325 10.12 5.19325 9.86Z",
    fill: "#17B471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassStep);
export default __webpack_public_path__ + "static/media/passStep.6a1c464a5aba830f0e0250878b0ac984.svg";
export { ForwardRef as ReactComponent };